import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        domainnameSelectOptions: [],  //部门下拉选项列表
        list: [], //table中的list显示数据
        pagination: {

        }, //分页相关的信息
        record: {}, //根据id查询的数据详情信息
    },

    getters: {
        getDomainnameSelectOptions (state) {
            return state.domainnameSelectOptions
        }
    },

    mutations: {
        save (state, action) {
            // console.log(action, "commit")
            // state = { ...state, ...action.payload }   //这么写不行，必须要遍历挨个重新赋值
            // state.domainnameSelectOptions = action.payload.domainnameSelectOptions
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
            // console.log(state, " yo ?") //跟console.log({ ...state, ...action.payload }) 的值是不一样的, 所以不能直接用展开运算符
        }
    },

    actions: {

        //查询File列表信息
        selectFile (context, payload) {
            payload.type = 'configcenter/queryfile'
            return D.select({
                ...payload
            })
        },
        //查询File列表信息
        selectMidFile (context, payload) {
            payload.type = 'configcenter/querymidfile'
            return D.select({
                ...payload
            })
        },
        addFile (context, payload) {
            payload.type = 'configcenter/addfile'
            return D.add({
                ...payload
            })
        },
        editFile (context, payload) {
            payload.type = 'configcenter/editfile'
            return D.edit({
                ...payload
            })
        },
        deleteFile (context, payload) {
            payload.type = 'configcenter/deletefile'
            return D.del({
                ...payload
            }).then(response => {
                context.dispatch('selectSys')
                return response
            })
        },
        queryConfigLogPage (context, payload) {
            payload.type = 'configcenter/queryconfiglogpage'
            return D.select({
                ...payload
            })
        },
        detailConfigLogPage (context, payload) {
            payload.type = 'configcenter/detailconfiglogpage'
            return D.select({
                ...payload
            })
        },


        cpu_add (context, payload) {
            return D.add({
                ...payload
            })
        },
        cpu_del (context, payload) {
            return D.del({
                ...payload
            })
        },
        cpu_edit (context, payload) {
            return D.edit({
                ...payload
            })
        },
        cpu_reflush (context, payload) {
            return D.select({
                ...payload
            })
        },
        cpu_detail (context, payload) {
            return D.select({
                ...payload
            })
        },
        cpu_page (context, payload) {
            return D.select({
                ...payload
            })
        },
        queryGlobal (context, payload) {
            return D.select({
                ...payload
            })
        },
        editGlobal (context, payload) {
            return D.edit({
                ...payload
            })
        },

    }
}
